import { MutationsCreator } from '@/store/utils';

export default MutationsCreator([
  {
    name: 'UPDATE_USERS_ME',
    state: 'updateUsersMe'
  }
]);
